<template>
  <!-- Popup Deposit -->
  <el-dialog
    title="Deposit"
    :visible.sync="isShowDepositAddressForm"
    class="medium wallet-dialog"
    :close-on-click-modal="false"
    @open="onOpen"
    >
    <div class="popup-inner" :class="{ 'loading': isProcessing }">
      <div class="item">
        <label>{{ $t('TEXT_WALLET') }}</label>
        <select v-model="selectedSymbol">
          <option v-for="balance in depositBalances" :value="balance.currency" :key="balance.currency">
            {{balance.currency}} ({{balance.name}})
          </option>
        </select>
      </div>
      <div class="item" v-if="selectedBalance.address">
        <label>Address</label>
        <p>{{selectedBalance.address}} <i @click="copy(selectedBalance.address)" class="el-icon-copy-document"></i></p>
      </div>
      <div class="item item-qr">
        <qr-code :size="200" :text="`${selectedBalance.address}`"></qr-code>
      </div>
      <div class="item item-wallet-connect" v-if="!isConnected">
        <a class="btn" @click.prevent="showWalletProviders"
        ><i class="el-icon-wallet"></i>{{ $t('BTN_WALLET_CONNECT') }}</a>
        <div class="item-tip">
          <i class="el-icon-info"></i>Note: You need to connect your wallet before making a deposit
        </div>
      </div>
      <div class="item item-deposit" v-else>
        <a class="btn" @click.prevent="openDeposit"
        >Deposit from your wallet</a>
      </div>
    </div>
  </el-dialog>
  <!-- End Popup Deposit -->
</template>

<script>
import Vue from 'vue'
import VueQRCodeComponent from 'vue-qrcode-component'
import CONSTANT from '@/configs/constant'
Vue.component('qr-code', VueQRCodeComponent)

export default {
  data () {
    return {
      endTime: '',
      selectedSymbol: 'USDT',
      selectedBalance: {},
      form: {
        amount: ''
      },
      isProcessing: false,
      second: null
    }
  },
  computed: {
    isConnected () {
      return this.$store.getters.isConnected
    },
    web3 () {
      return this.$store.getters.web3
    },
    balances () {
      return this.$store.getters.balances
    },
    depositBalances () {
      return this.balances.filter(balance => {
        return balance.is_allow_deposit
      })
    },
    isShowDepositAddressForm: {
      get () {
        return this.$store.getters.isShowDepositAddressForm
      },
      set () {
        this.$store.dispatch('toggleDepositAddressForm')
      }
    },
    isValidated () {
      return this.form.amount && !isNaN(this.form.amount) && parseFloat(this.form.amount) > 0
    },
    configs () {
      return this.$store.getters.configs
    }
  },
  watch: {
    selectedSymbol (symbol) {
      if (symbol) {
        this.selectedBalance = this.depositBalances.filter(temp => temp.currency === symbol)[0]
      }
    }
  },
  methods: {
    showSwitchChain () {
      this.$confirm('Please switch wallet to correct network', 'Warning', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Switch',
        cancelButtonText: 'Cancel'
      }).then(() => {
        this.$store.dispatch('switchChain', this.configs.bscChainId)
      }).catch(() => {
      })
    },
    async checkWalletConnect () {
      const rs = await this.$store.dispatch('getAccountConnect')
      if (rs === CONSTANT.TYPES_CONNECT.INJECT) {
        const ethereum = window.ethereum
        const networkVersion = parseInt(ethereum.networkVersion)
        console.log('🚀 ~ file: DashboardLayout.vue:128 ~ mounted ~ networkVersion:', networkVersion)
        if (ethereum && ethereum.networkVersion && networkVersion !== this.configs.bscChainId && this.isConnected) {
          this.showSwitchChain()
          return false
        }
      } else {
        console.log('handle for wallet connect')
      }
      return true
    },
    openDeposit () {
      if (!this.isConnected) {
        this.showWalletProviders()
        return
      }
      this.checkWalletConnect().then(rs => {
        console.log(rs)
        rs && this.$store.dispatch('toggleDepositForm')
      })
    },
    showWalletProviders () {
      this.$store.dispatch('toggleWalletProviderForm')
    },
    onOpen () {
      this.selectedBalance = this.depositBalances.filter(temp => temp.currency === this.selectedSymbol)[0]
    },
    copy (text) {
      this.$copyText(text).then(e => {
        this.$store.dispatch('showSuccessMsg', this.$t('TEXT_COPIED', 'Copied'))
      })
    }
  }
}
</script>
